export default __webpack_public_path__ + "static/media/logo-ksr-white-medium.8a154a06.png";